/** CoStar.Api.ExternalApi.ViewModels.MultipleTypeAhead.MatchType */
export var MatchType;
(function (MatchType) {
    MatchType[MatchType["Unknown"] = 0] = "Unknown";
    MatchType[MatchType["Property"] = 1] = "Property";
    MatchType[MatchType["PostalCode"] = 2] = "PostalCode";
    MatchType[MatchType["City"] = 3] = "City";
    MatchType[MatchType["BuildingName"] = 4] = "BuildingName";
    MatchType[MatchType["Submarket"] = 5] = "Submarket";
    MatchType[MatchType["Street"] = 6] = "Street";
    MatchType[MatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MatchType[MatchType["Contact"] = 8] = "Contact";
    MatchType[MatchType["Company"] = 9] = "Company";
    MatchType[MatchType["County"] = 10] = "County";
    MatchType[MatchType["Subdivision"] = 11] = "Subdivision";
    MatchType[MatchType["GeocodeResult"] = 12] = "GeocodeResult";
    MatchType[MatchType["BuildingPark"] = 13] = "BuildingPark";
    MatchType[MatchType["ShoppingCenter"] = 14] = "ShoppingCenter";
    MatchType[MatchType["Country"] = 15] = "Country";
    MatchType[MatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MatchType[MatchType["Region"] = 17] = "Region";
    MatchType[MatchType["StoreType"] = 18] = "StoreType";
    MatchType[MatchType["TransitStation"] = 19] = "TransitStation";
    MatchType[MatchType["PropertyResidential"] = 20] = "PropertyResidential";
    MatchType[MatchType["MultifamilyProperty"] = 21] = "MultifamilyProperty";
    MatchType[MatchType["Airport"] = 22] = "Airport";
    MatchType[MatchType["HotelName"] = 23] = "HotelName";
    MatchType[MatchType["TransitStation2"] = 24] = "TransitStation2";
    MatchType[MatchType["Military"] = 25] = "Military";
    MatchType[MatchType["University"] = 26] = "University";
    MatchType[MatchType["StoreBrand"] = 27] = "StoreBrand";
    MatchType[MatchType["GoogleResults"] = 28] = "GoogleResults";
    MatchType[MatchType["PropertyManagers"] = 29] = "PropertyManagers";
    MatchType[MatchType["SearchEngineOptimization"] = 30] = "SearchEngineOptimization";
    MatchType[MatchType["Metro"] = 31] = "Metro";
    MatchType[MatchType["SaleCompID"] = 32] = "SaleCompID";
    MatchType[MatchType["SubmarketCluster"] = 34] = "SubmarketCluster";
    MatchType[MatchType["MSA"] = 35] = "MSA";
    MatchType[MatchType["PropertyGroup"] = 36] = "PropertyGroup";
    MatchType[MatchType["CompEntity"] = 50] = "CompEntity";
    MatchType[MatchType["Comp"] = 51] = "Comp";
    MatchType[MatchType["ForSale"] = 52] = "ForSale";
    MatchType[MatchType["ContactSaleComp"] = 81] = "ContactSaleComp";
    MatchType[MatchType["ContactShoppingCenter"] = 82] = "ContactShoppingCenter";
    MatchType[MatchType["ContactLeaseDeal"] = 83] = "ContactLeaseDeal";
    MatchType[MatchType["ContactTenant"] = 84] = "ContactTenant";
    MatchType[MatchType["ContactProperty"] = 85] = "ContactProperty";
    MatchType[MatchType["SubscriptionContact"] = 86] = "SubscriptionContact";
    MatchType[MatchType["CompanySaleComp"] = 91] = "CompanySaleComp";
    MatchType[MatchType["CompanyShoppingCenter"] = 92] = "CompanyShoppingCenter";
    MatchType[MatchType["CompanyLeaseDeal"] = 93] = "CompanyLeaseDeal";
    MatchType[MatchType["StreetIntersection"] = 131] = "StreetIntersection";
    MatchType[MatchType["CoStarMarket"] = 132] = "CoStarMarket";
    MatchType[MatchType["TrueCity"] = 133] = "TrueCity";
    MatchType[MatchType["CensusRegion"] = 134] = "CensusRegion";
    MatchType[MatchType["Continent"] = 135] = "Continent";
    MatchType[MatchType["Subcontinent"] = 136] = "Subcontinent";
    MatchType[MatchType["Fund"] = 137] = "Fund";
    MatchType[MatchType["CompanyFund"] = 138] = "CompanyFund";
    MatchType[MatchType["RetailBrand"] = 139] = "RetailBrand";
    MatchType[MatchType["Tenant"] = 140] = "Tenant";
    MatchType[MatchType["TenantCompany"] = 141] = "TenantCompany";
    MatchType[MatchType["PostalCodeGlobal"] = 142] = "PostalCodeGlobal";
})(MatchType || (MatchType = {}));
/** CoStar.Api.ExternalApi.ViewModels.MultipleTypeAhead.SearchType */
export var SearchType;
(function (SearchType) {
    SearchType[SearchType["EntityCountProperty"] = 0] = "EntityCountProperty";
    SearchType[SearchType["EntityCountForLease"] = 1] = "EntityCountForLease";
    SearchType[SearchType["EntityCountForSale"] = 2] = "EntityCountForSale";
    SearchType[SearchType["EntityCountLeaseComp"] = 3] = "EntityCountLeaseComp";
    SearchType[SearchType["EntityCountSaleComp"] = 4] = "EntityCountSaleComp";
    SearchType[SearchType["EntityCountTenant"] = 5] = "EntityCountTenant";
})(SearchType || (SearchType = {}));
/** CoStar.Api.ExternalApi.ViewModels.MultipleTypeAhead.PropertyType */
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["None"] = 0] = "None";
    PropertyType[PropertyType["Hospitality"] = 1] = "Hospitality";
    PropertyType[PropertyType["Industrial"] = 2] = "Industrial";
    PropertyType[PropertyType["Land"] = 3] = "Land";
    PropertyType[PropertyType["Unknown"] = 4] = "Unknown";
    PropertyType[PropertyType["Office"] = 5] = "Office";
    PropertyType[PropertyType["GeneralRetail"] = 6] = "GeneralRetail";
    PropertyType[PropertyType["Flex"] = 7] = "Flex";
    PropertyType[PropertyType["SportsEntertainment"] = 8] = "SportsEntertainment";
    PropertyType[PropertyType["MixedUse"] = 9] = "MixedUse";
    PropertyType[PropertyType["Specialty"] = 10] = "Specialty";
    PropertyType[PropertyType["Multifamily"] = 11] = "Multifamily";
    PropertyType[PropertyType["Healthcare"] = 13] = "Healthcare";
    PropertyType[PropertyType["Residential"] = 15] = "Residential";
})(PropertyType || (PropertyType = {}));
